// PreviousPathContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import config from "config";
const PreviousPathContext = createContext();

export const PreviousPathProvider = ({ children }) => {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState("");
  const api = config.backOffice.apiName;
  useEffect(() => {
    const currentPath = location.pathname;

    setPreviousPath((prev) => {
      if (
        prev.includes("login") ||
        prev.includes("logout") ||
        prev.includes("forgot-password") ||
        prev == "" ||
        currentPath.includes("login") ||
        currentPath.includes("logout") ||
        currentPath.includes("forgot-password")
      ) {
        return currentPath;
      } else {
        localStorage.setItem("previousPath_" + api, prev);
      }

      return currentPath;
    });
  }, [location]);

  return (
    <PreviousPathContext.Provider value={previousPath}>
      {children}
    </PreviousPathContext.Provider>
  );
};

export const usePreviousPath = () => useContext(PreviousPathContext);
